import { fileUrl } from "@/components/ImageUpload";

const W = 1080;
const H = 1350;
const NAVY = "hsl(218, 62%, 15%)";
const COPPER = "hsl(26, 50%, 51%)";
const PLACE = { 1: "1st Place · Champion", 2: "2nd Place · Reserve" };

const loadPhoto = async (src) => {
  if (!src) return null;
  try {
    const res = await fetch(fileUrl(src));
    return await createImageBitmap(await res.blob());
  } catch {
    return null;
  }
};

const drawCover = (ctx, img, w, h) => {
  const s = Math.max(w / img.width, h / img.height);
  ctx.drawImage(img, (w - img.width * s) / 2, (h - img.height * s) / 2, img.width * s, img.height * s);
};

const fitText = (ctx, text, max, size, weight, family) => {
  let px = size;
  do { ctx.font = `${weight} ${px}px ${family}`; px -= 4; } while (ctx.measureText(text).width > max && px > 30);
};

// Renders a 4:5 social card (photo + placing, division, horse, trainer, event) as a PNG blob.
export const buildWinnerCard = async (w, division) => {
  await document.fonts?.ready;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = NAVY; ctx.fillRect(0, 0, W, H);
  const img = await loadPhoto(w.photo);
  if (img) drawCover(ctx, img, W, H);
  const g = ctx.createLinearGradient(0, H * 0.35, 0, H);
  g.addColorStop(0, "rgba(13, 27, 49, 0)"); g.addColorStop(0.55, "rgba(13, 27, 49, 0.85)"); g.addColorStop(1, "rgba(13, 27, 49, 0.98)");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);

  ctx.fillStyle = COPPER; ctx.fillRect(0, 0, W, 14);
  ctx.textBaseline = "alphabetic"; ctx.textAlign = "left";
  const x = 72;
  ctx.fillStyle = COPPER; ctx.font = "800 34px Manrope, sans-serif";
  ctx.fillText(`${PLACE[w.placing] || `Placing #${w.placing}`}${w.tied ? " (tie)" : ""}`.toUpperCase(), x, H - 420);
  ctx.fillStyle = "rgba(255,255,255,0.85)"; ctx.font = "700 40px Manrope, sans-serif";
  ctx.fillText(division, x, H - 360);
  ctx.fillStyle = "#ffffff";
  fitText(ctx, w.horse_name, W - x * 2, 120, 800, "\"Playfair Display\", Georgia, serif");
  ctx.fillText(w.horse_name, x, H - 245);
  ctx.fillStyle = "rgba(255,255,255,0.8)"; ctx.font = "600 38px Manrope, sans-serif";
  ctx.fillText(`HIP #${w.hip_number} · Trainer ${w.trainer_name || ""}`.trim(), x, H - 165);
  ctx.fillStyle = "rgba(255,255,255,0.25)"; ctx.fillRect(x, H - 125, W - x * 2, 2);
  ctx.fillStyle = "#ffffff"; ctx.font = "700 italic 40px \"Playfair Display\", Georgia, serif";
  ctx.fillText("Bluegrass Mustang Makeover 2026", x, H - 66);
  ctx.textAlign = "right"; ctx.fillStyle = COPPER; ctx.font = "800 44px Manrope, sans-serif";
  ctx.fillText(String(w.overall_total), W - x, H - 66);
  return new Promise((resolve) => c.toBlob(resolve, "image/png"));
};
